import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../modules/shared/shared.module';
import { RouterModule, Routes } from '@angular/router';
import { EmailRecordsComponent } from './email-records/email-records.component';
import { EmailauditService } from './email-records/service/emailreaudit.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EmailconfigService } from './email-configuration/service/emailconfigservice.service';
import { EmailConfigurationComponent } from './email-configuration/email-configuration.component';
import { EmailFileuploadComponent } from './email-fileupload/email-fileupload.component';
import { confirmationGuard } from '../../../confirmation/confirmation.guard';

const routes:Routes=[
  {
    path:'emailRecords',component:EmailRecordsComponent
  }, {path:'emailfileUpload',component:EmailFileuploadComponent,canDeactivate:[confirmationGuard]},
  {
    path:'emailconfiguration',
    component:EmailConfigurationComponent
  },
  {
    redirectTo:'emailRecords',
    pathMatch:'full',
    path:''
  }
];

@NgModule({
  declarations: [EmailFileuploadComponent,EmailRecordsComponent,EmailConfigurationComponent],
  imports: [
     CommonModule,
        SharedModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule.forChild(routes)
  ],
  providers:[EmailauditService,EmailconfigService],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class EmailAuditModule { }
